/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { connect } from 'react-redux';
import CreationModule from "../CreationModule";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import AlertMpgPreview from "../AlertMpgPreview";
import { calculateTarget } from "../../../actions/entities/notificationsCenter";
import swal from "sweetalert2";
import {scrollToTop} from "../../../helpers/utils";
import TargetingQueries from "../../../components/TargetingQueries";
import unset from "lodash/unset";
import get from "lodash/get";
import forEach from "lodash/forEach";
import { getAlert, sendAlertUsersTest, updateAlert, validateAlertInApp } from "../../../actions/entities/alertMPG";
import SendTestUser from "../../Notifications/SendTestUser";

class notificationModify extends React.Component {
    state = {
        data: {},
        counts: null,
        error: {},
    };

    componentDidMount() {
        const { dispatch } = this.props;
        const onSuccess = (response) => this.setState({ data: response });
        dispatch(getAlert(this.props.match.params.alertId, onSuccess));
        scrollToTop();
    }

    onChangeInput = (value, keys) => {
        this.setState({ data: set(this.state.data, keys, value || value === false ? value : undefined) });
    };

    clean(object) {
        Object
            .entries(object)
            .forEach(([k, v]) => {
                if (v && typeof v === 'object') {
                    this.clean(v);
                }
                if ((v && typeof v === 'object' && !Object.keys(v).length) || v === null || v === undefined) {
                    if (Array.isArray(object)) {
                        object.splice(k, 1);
                    } else {
                        delete object[k];
                    }
                }
            });
        return object;
    }

    updateAlert = () => {
        const { data } = this.state;
        const { dispatch } = this.props;
        const compactData = this.clean(cloneDeep(data));
        delete compactData.status;
        delete compactData.type;
        const onError = (error) => swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${error}<br/>`,
        });
        const onSuccess = () => swal({
            title: `Updated !`,
            type: 'success',
        });
        dispatch(updateAlert(compactData.id, compactData, onSuccess, onError));
    };

    onChangeTargetingData = (value, key) => {
        this.setState({ data: { ...this.state.data, targetFields: set(this.state.data.targetFields, key, value) }});
    };

    deleteTargetingQuery = (key) => {
        const freshData = this.state.data.targetFields;
        unset(freshData, key);
        const parentKey = key.split('.');
        parentKey.splice(key.split('.').length - 1, 1);
        const parent = get(freshData, parentKey.join('.')) || freshData;
        const normalize = (object) => {
            let i = 1;
            const newParent = {};
            forEach(object, o => {
                newParent[i] = o;
                if (i === 1) delete newParent[i].operator;
                i++;
            });
            set(freshData, parentKey, newParent);
        };
        normalize(parent);
        this.setState({ data: { ...this.state.data, targetFields: freshData }});
    };

    addTargetingQuery = (key) => {
        const freshData = this.state.data.targetFields;
        let parent = get(freshData, key);
        if (parent.type === 'group') {
            if (!Object.keys(parent.fields).length) {
                parent = {
                    type: "field",
                    name: "id",
                    fieldType: "string",
                    operation:  "equal",
                    parameter: ""
                };
                set(freshData, key, parent);
            } else {
                const needOperator = Object.keys(parent.fields).length >= 1 || undefined;
                parent.fields[Object.keys(parent.fields).length ? parseInt(Object.keys(parent.fields)[Object.keys(parent.fields).length - 1], 10) + 1 : 1] = {
                    operator: needOperator && 'AND',
                    type: "field",
                    name: "id",
                    fieldType: "string",
                    operation:  "equal",
                    parameter: ""
                };
            }
        } else {
            parent = {
                type: 'group',
                operator: parent.operator,
                fields: {
                    1: {
                        ...parent,
                        type: 'field',
                        operator: undefined
                    },
                    2: {
                        operator: "AND",
                        type: "field",
                        name: "id",
                        fieldType: "string",
                        operation:  "equal",
                        parameter: ""
                    }
                }
            };
            set(freshData, key, parent);
        }
        this.setState({ data: { ...this.state.data, targetFields: freshData }});
    };

    onChangeOperator = (key) => {
        const freshData = this.state.data.targetFields;
        const parent = get(freshData, key);
        parent.operator = parent.operator === 'AND' ? 'OR' : 'AND';
        this.setState({ data: { ...this.state.data, targetFields: freshData }});
    };

    addFirstQuery = () => {
        this.setState({
            data: {
                ...this.state.data,
                targetFields: {
                    1: {
                        type: "field",
                        name: "id",
                        fieldType: "string",
                        operation:  "equal",
                        parameter: ""
                    },
                }
            },
        })
    };

    addCustomQuery() {
        this.setState({
            data: {
                ...this.state.data,
                targetQuery: '',
            },
        })
    }

    calculateTarget = (type) => {
        const { dispatch } = this.props;
        const { data } = this.state;
        const onSuccess = (response) => {
            this.setState({ counts: response, loading: false });
        };
        const onError = (error) => {
            this.setState({ loading: false });
            swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong !<br/>${error}<br/>`,
            });
        };
        const onRequest = () => this.setState({ loading: true });
        dispatch(calculateTarget({ [type]: data[type] }, onSuccess, onError, onRequest));
    };

    onValidate = () => {
        const { dispatch } = this.props;
        const { data } = this.state;
        if (data.alertType === 'targeted' && data.targetFields && !Object.keys(data.targetFields).length) {
            this.setState({ error: { alertType: true } });
            window.scrollTo(0, 0);
        } else {
            swal({
                title: 'Are you sure ?',
                type: 'info',
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText:
                    'Yes',
                cancelButtonText:
                    'No',
            }).then(() => {
                dispatch(validateAlertInApp(this.props.match.params.alertId, () => this.setState({ error: { alertType: false }, data: { ...this.state.data, status: 1 } })));
            }).catch(error => {
                console.log(error);
            })
        }
    };

    submitTestUsers = () => {
        const { usersForTest } = this.state;
        if (usersForTest) {
            const usersIds = usersForTest.split(';').reduce((result, value) => {
                if (value) {
                    result.push(`mpg_user_${value}`);
                }
                return result;
            }, []);
            const onSuccess = () => {
                this.setState({ usersForTest: null });
                swal({
                    title: `Success!`,
                    text: `Test send to : ${JSON.stringify(usersIds)}`,
                    type: 'success',
                });
            };
            this.props.dispatch(sendAlertUsersTest(this.props.match.params.alertId, { usersIds }, onSuccess))
        }
    };

    render() {
        const { data, loading, error } = this.state;
        return (
            <div id="alertInAppModify">
                <header className="content-header">
                    <h1>
                        Alert in app MPG
                        <small>Modify</small>
                    </h1>
                </header>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <CreationModule error={error} data={data} onChangeInput={this.onChangeInput} />
                            <AlertMpgPreview data={data} />
                        </div>
                        {!!Object.keys(data).length && data.alertType === 'targeted' && (
                            <div className="col-md-12">
                                <div id="targetingQueries" className="box box-default">
                                    <div className="box-header with-border">
                                        <h3 className="box-title pull-left">
                                            Targeting: <a href="https://docs.google.com/spreadsheets/d/1567fjuysyUYywDF5PIBG6Xin1vBryTDVbfkYnFL82BM/edit#gid=0" target="_blank">liste des variables</a>
                                        </h3>
                                    </div>
                                    <div className="p-5">
                                        {
                                            data.targetFields && !!Object.keys(data.targetFields).length && (
                                                <React.Fragment>
                                                    <div className="text-center countsContainer">
                                                        <button
                                                            disabled={!data.alertType}
                                                            onClick={() => this.calculateTarget('targetFields')}
                                                            className="btn btn-success"
                                                        >
                                                            Calculate
                                                        </button>
                                                        {this.state.counts && (
                                                            <React.Fragment>
                                                                <div style={{ margin: '0 20px' }}>
                                                                    <div className="m-3">Target volume users :</div>
                                                                    <div className="count">{this.state.counts.totalCount ? this.state.counts.totalCount.toLocaleString() : 0}</div>
                                                                </div>
                                                                <div>
                                                                    <div className="m-3">Target Volume users last <br/>connexion 21 days:</div>
                                                                    <div className="count">{this.state.counts.recentlyConnectedCount ? this.state.counts.recentlyConnectedCount.toLocaleString() : 0}</div>
                                                                </div>
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                    <TargetingQueries
                                                        onChange={this.onChangeTargetingData}
                                                        data={data.targetFields}
                                                        onDelete={this.deleteTargetingQuery}
                                                        onAdd={this.addTargetingQuery}
                                                        onChangeOperator={this.onChangeOperator}
                                                    />
                                                </React.Fragment>
                                            )
                                        }
                                        {
                                            ((!data.targetFields || (data.targetFields && !Object.keys(data.targetFields).length)) && !data.targetQuery && data.targetQuery !== '') && (
                                                <div className="text-center">
                                                    <div style={{ marginBottom: '30px' }}>
                                                        <i className="fa fa-plus-circle addIcon" onClick={() => this.addFirstQuery()} />
                                                    </div>
                                                    <div>
                                                        <div style={{ margin: '10px' }}>Or custom target:</div>
                                                        <i style={{ color: 'red' }} className="fa fa-plus-circle addIcon" onClick={() => this.addCustomQuery()} />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div>
                                        {
                                            (data.targetQuery || data.targetQuery === '') && (
                                                <div className="text-center">
                                                    <div className="text-center countsContainer" style={{ minHeight: '50px', margin: '20px' }}>
                                                        {loading ? <i style={{ fontSize: '24px' }} className="fa fa-spin fa-circle-o-notch"/> : (
                                                            <button
                                                                disabled={!data.alertType}
                                                                onClick={() => this.calculateTarget('targetQuery')}
                                                                className="btn btn-success"
                                                            >
                                                                Calculate
                                                            </button>
                                                        )}
                                                        {this.state.counts && !loading && (
                                                            <React.Fragment>
                                                                <div style={{ margin: '0 20px' }}>
                                                                    <div className="m-3">Target volume users :</div>
                                                                    <div className="count">{this.state.counts.totalCount ? this.state.counts.totalCount.toLocaleString() : 0}</div>
                                                                </div>
                                                                <div>
                                                                    <div className="m-3">Target Volume users last <br/>connexion 21 days:</div>
                                                                    <div className="count">{this.state.counts.recentlyConnectedCount ? this.state.counts.recentlyConnectedCount.toLocaleString() : 0}</div>
                                                                </div>
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                    <textarea
                                                        className="form-control"
                                                        value={data.targetQuery}
                                                        onChange={(event) => this.setState({ data: { ...this.state.data, targetQuery: event.target.value} })}
                                                    />
                                                    <div style={{ margin: '10px' }}>
                                                        <i className="fa fa-trash-o deleteIcon" onClick={() => this.setState({ data: { ...this.state.data, targetQuery: null } })} />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div style={{ margin: 'auto', width: '50%', textAlign: 'center' }}>
                                        <SendTestUser
                                            value={this.state.usersForTest}
                                            onChange={
                                                (event) => this.setState({ usersForTest: event.target.value })
                                            }
                                            onClick={this.submitTestUsers}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
                <div className="text-center p-5">
                    <button onClick={this.updateAlert} className="btn btn-success" >Modify</button>
                    <button disabled={data.alertType !== 'targeted' || data.status !== 0} onClick={this.onValidate} className="btn btn-danger m-3">Validate</button>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        list: state.app.notificationsCenter.list.list,
    }),
    dispatch => ({ dispatch }),
)(notificationModify);



// WEBPACK FOOTER //
// ./src/pages/AlertMPG/Modify/index.js